<app-header-title>
  <span title>{{'hr.EmployeeStatus' |translate}}</span>
</app-header-title>

<div id="data-grid-demo">
  <div class="publicsetting" style="padding: 0rem 3rem;">
    <button class="btn " (click)="onSendClick()">Send Mail</button>
    <dx-data-grid
      #grid
      class="dx-card wide-card"
      [dataSource]="allEmployeeStatus"
      (onSelectionChanged)="onSelectionChanged($event)"
      [showBorders]="false"
      [focusedRowEnabled]="true"
      [focusedRowIndex]="0"
      [allowColumnResizing]="true"
      [columnAutoWidth]="true"
      [columnHidingEnabled]="false"
      [showColumnLines]="false"
      [rowAlternationEnabled]="true"
      [showRowLines]="false"
      [showBorders]="false"
      [errorRowEnabled]="false"
      [columnMinWidth]="80"
      [rtlEnabled]="currentLang=='ar'?true:false"
      (onInitNewRow)="goToEmployeeStatus($event)"
      (onEditingStart)="goToEmployeeStatus($event)"
    >
      <dxo-editing mode="row" [allowUpdating]="true" [allowAdding]="false" [allowDeleting]="false">
      </dxo-editing>
<dxo-scrolling mode="standard" columnRenderingMode="standard"></dxo-scrolling>
      <dxo-paging [pageSize]="10"></dxo-paging>
      <dxo-pager
        [visible]="true"
        allowedPageSizes="true"
        displayMode="full"
        [showPageSizeSelector]="true"
        [showInfo]="false"
        [showNavigationButtons]="true"
      >
      </dxo-pager>

      <dxo-filter-row [visible]="true"></dxo-filter-row>

      <dxo-selection mode="multiple" [showCheckBoxesMode]="'always'"></dxo-selection>

      <dxi-column dataField="nameAr" caption="{{'hr.NameAr'|translate}}"></dxi-column>
     
      <dxi-column dataField="managementName" caption="{{'hr.managementName'|translate}}"></dxi-column>
      <dxi-column dataField="isActive" caption="{{'hr.EmployeeStatus'|translate}}"></dxi-column>
      <dxi-column dataField="employeeWorkStatus" caption="{{'hr.EmployeeWorkStatus'|translate}}">     
         
        <dxo-lookup [dataSource]="employeeWorkStatusMenu" valueExpr="code" displayExpr="name"></dxo-lookup>
      </dxi-column>      
      <dxi-column dataField="branchId" [allowEditing]="false" caption="الــفــروع">
        <dxo-lookup [dataSource]="branches" valueExpr="id" displayExpr="nameAr"></dxo-lookup>
      </dxi-column>
      <dxi-column dataField="dateOfHiring" caption="تــاريــخ الـتـعـين"></dxi-column>
    <dxi-column dataField="endContractDate" caption="تاريخ نهاية العقد"></dxi-column>
    <dxi-column dataField="resignationDate" caption="تاريخ الاستقالة"></dxi-column>
    <dxi-column dataField="approvalResignationDate" caption="تاريخ اعتماد الاستقالة"></dxi-column>
<dxi-column
    dataField="changeEmployeeStatusDate"
    caption="تاريخ تغيير حالة العمل"
    dataType="date"
    format="shortDate">
</dxi-column>


      <dxi-column type="buttons">
        <dxi-button name="edit" text="{{'tableinfo.editbutton'|translate}}"></dxi-button>
      </dxi-column>

      <dxo-remote-operations [groupPaging]="true"></dxo-remote-operations>

     
      <!-- <dxo-toolbar>
        <form>
        <dx-form [formData]="[]" [showColonAfterLabel]="true" [showValidationSummary]="true"
                style="padding: 1rem 2rem;margin: 2rem 0rem;" [rtlEnabled]="currentLang=='ar'?true:false"
                validationGroup="true">
        <dxi-item location="after" widget="dxButton" itemType="button" [buttonOptions]="sendoptions">send</dxi-item>
        </dx-form>
        </form>
      </dxo-toolbar> -->
    </dx-data-grid>
  </div>
</div>
